import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectSearch = state => state.get('search', initialState);

const makeSelectParam = () =>
  createSelector(selectSearch, selectedState => selectedState.get('params'));

const makeSelectLoading = () =>
  createSelector(selectSearch, selectedState => selectedState.get('loading'));

const makeSelectSelectedParams = () =>
  createSelector(selectSearch, selectedState =>
    selectedState.get('selectedParams').toArray(),
  );

const makeSelectLabels = () =>
  createSelector(selectSearch, selectedState => {
    const params = selectedState.get('selectedParams').toArray();
    return params
      .map(item => {
        if (
          item.value !== undefined &&
          item.value !== null &&
          item.value.length > 0
        )
          return {
            value: item.value,
            name: item.name,
            label: item.label,
          };
        return false;
      })
      .filter(obj => obj.hasOwnProperty('value'));
  });

export {
  selectSearch,
  makeSelectLoading,
  makeSelectParam,
  makeSelectLabels,
  makeSelectSelectedParams,
};
